import { Collapse, Table, TableCell } from '@mui/material';
import styled from 'styled-components';
import { mainColumnHeaders } from '../TransportCloudTable.consts';
import { COLORS, SHADOWS } from './constants';

export const StyledTable = styled(Table)`
  box-shadow: ${SHADOWS.table};
  border-radius: 5px;
  table-layout: auto;
  min-width: max-content;
`;

export const InnerTable = styled(Table)`
  min-width: max-content;
  table-layout: auto;
  background-color: ${COLORS.white};

  ${Object.keys(mainColumnHeaders)
    .map(
      (col) =>
        `&[data-hover-column="${col}"] th[data-column="${col}"],
         &[data-hover-column="${col}"] td[data-column="${col}"] {
           background-color: ${COLORS.lightGray} !important;
           color: ${COLORS.textGray} !important;
         }`,
    )
    .join('\n')}

  & thead {
    position: sticky;
    top: 0;
    z-index: 50;
  }

  & thead::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: rgba(224, 224, 224, 1);
    z-index: 51;
  }

  & thead th {
    background-color: ${COLORS.white};
  }
`;

export const StyledTableCell = styled(TableCell)`
  padding: 0.75rem !important;
  vertical-align: middle;
  height: auto;
  min-height: 0;
  line-height: 1.2;
`;

export const StyledTableDataCell = styled(TableCell)`
  font-size: 0.6rem;
  font-weight: 600;
  background-color: ${COLORS.mediumGray};
  padding: 5px 0.45rem !important;
  height: auto;
  min-height: 0;
  vertical-align: middle;
  line-height: 1.2;
`;

export const StickyDateLabel = styled.span`
  position: sticky;
  left: 8px;
  display: inline-block;
`;

export const PaginationCell = styled(TableCell)`
  padding: 0 6px;
`;

export const CollapseContentBox = styled(Collapse)`
  background-color: ${COLORS.lightGray};
`;

export const CollapseHeader = styled(TableCell)`
  color: ${COLORS.textGray};
`;

export const CellContentWrapper = styled.div`
  max-width: 500px;
  white-space: normal;
  word-break: break-word;
  min-height: 0;
  line-height: 1.2;
  display: flex;
  align-items: center;
`;
